import { ColaOffline, type Almacen, type Mutacion, type ResultadoEnvio } from '@barbones/shared';
import { api, ErrorApi, usarManejadorSinRed, usuarioActualId } from '../cliente';

/**
 * Qué puede hacerse sin conexión. Agenda, clientes, atención y el carrito se guardan y se envían
 * al volver la red; lo que mueve dinero (caja, cobro, devoluciones) o archivos exige conexión.
 */
const REQUIEREN_CONEXION = [/^\/caja\b/, /^\/ventas\/[^/]+\/(cobrar|devoluciones|cancelar)$/, /^\/importacion\b/, /^\/auth\b/, /^\/nomina\b/, /^\/aprobaciones\b/];
const ENCOLABLES = [/^\/citas\b/, /^\/atencion\b/, /^\/clientes\b/, /^\/ventas\/[^/]+\/lineas\b/, /^\/ventas$/, /^\/asistencia\b/];

export function clasificarMutacion(ruta: string, _method: string): 'encolable' | 'requiere_conexion' | 'normal' {
  if (REQUIEREN_CONEXION.some((r) => r.test(ruta))) return 'requiere_conexion';
  if (ENCOLABLES.some((r) => r.test(ruta))) return 'encolable';
  return 'normal';
}

/** localStorage: la cola es pequeña y debe sobrevivir a recargas y cierres del navegador. */
const almacen: Almacen = {
  leer: async (clave) => localStorage.getItem(`bb:${clave}`),
  escribir: async (clave, valor) => localStorage.setItem(`bb:${clave}`, valor),
};

async function enviar(m: Mutacion): Promise<ResultadoEnvio> {
  // La cola vive en localStorage (editable por quien use el equipo): antes de enviar con la sesión
  // actual se exige que el cambio sea de esta misma persona y de una ruta permitida sin conexión.
  if (!m.propietario || m.propietario !== usuarioActualId() || clasificarMutacion(m.ruta, m.method) !== 'encolable') return 'conflicto';
  try {
    await api(m.ruta, { method: m.method, body: m.body, idempotencyKey: m.id, desdeCola: true });
    return 'ok';
  } catch (error) {
    // 4xx: el servidor ya decidió (empalme, regla); 5xx o sin red: se reintenta después.
    if (error instanceof ErrorApi && error.status < 500 && error.status !== 401) return 'conflicto';
    return 'reintentar';
  }
}

export const colaWeb = new ColaOffline(almacen, enviar);

usarManejadorSinRed({
  clasificar: clasificarMutacion,
  encolar: (m) => colaWeb.encolar({ ...m, descripcion: `${m.method} ${m.ruta}` }),
});

/** Borra la cola (al cerrar sesión en un equipo compartido). */
export async function vaciarCola(): Promise<void> {
  localStorage.removeItem('bb:cola:pendientes');
  localStorage.removeItem('bb:cola:conflictos');
}
